import React, { useState } from "react";
import BookListSection from "../components/booklist/BookListsSection";
import { useDispatch, useSelector } from "react-redux";
import { changeStatusFilter } from "../features/filters/filtersReducer";

const HomePage = () => {
  const { status } = useSelector((state) => state.filters);
  const [activeStatusFilterValue, setStatusActiveFilterValue] =
    useState(status);
  const dispatch = useDispatch();

  // Function to change the filter status and change the activeStatusFilterValue...
  const handleStatusFilterChange = (value) => {
    if (value !== activeStatusFilterValue) {
      setStatusActiveFilterValue(value);
      dispatch(changeStatusFilter(value));
    }
  };

  return (
    <main className="py-12 px-6 2xl:px-6 container">
      <div className="order-2 xl:-order-1">
        <div className="flex items-center justify-between mb-12">
          <h4 className="mt-2 text-xl font-bold">Book List</h4>
          {/* filter Buttons */}
          <div className="flex items-center space-x-4">
            <button
              className={`${
                activeStatusFilterValue === "All" && " active-filter"
              } lws-filter-btn`}
              value="All"
              onClick={(e) => handleStatusFilterChange(e.target.value)}
            >
              All
            </button>
            <button
              className={`${
                activeStatusFilterValue === "Featured" && " active-filter"
              } lws-filter-btn`}
              value="Featured"
              onClick={(e) => handleStatusFilterChange(e.target.value)}
            >
              Featured
            </button>
          </div>
        </div>
        {/* book list section */}
        <BookListSection />
      </div>
    </main>
  );
};

export default HomePage;
